import KM from '@ott/utility-km';
import makeKmData from './makeKmData';

export const successEvent = (name: string) => {
  KM(name, {
    obj: {
      result: 'success',
    },
  });
};

export const wrongPinEvent = (name: string) => {
  KM(name, {
    obj: {
      result: 'wrongPin',
    },
  });
};

export const authLoginResultEvent = () => {
  KM('Auth_Popup_Login_Result', makeKmData());
};

export const userNotFoundEvent = (name: string) => {
  KM(name, {
    obj: {
      result: 'userNotFound',
    },
  });
};

export const wrongPasswordEvent = (name: string) => {
  KM(name, {
    obj: {
      result: 'wrongPswd',
    },
  });
};

export const userExistsEvent = (name: string) => {
  KM(name, {
    obj: {
      result: 'userExists',
    },
  });
};

export const registerSuccessEvent = () => {
  KM('Auth_Popup_NewUser_Register_Click', makeKmData());
};
